import React, { useEffect } from "react";
import { Card, Col, Container, Form, Image, Row } from "react-bootstrap";
import {
    faBed,
    faFaceSmile, faHouse, faVenus
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Calendar, CalendarBlack, Card1, Task1, User1, User2 } from "../../../../assets/images";
import { dateFormat, timeFormat, timeInAgoFormat } from "../../../Helper/General";
import * as Constants from "../../../Helper/constants/constants";
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
import AssignedMemberModal from "../../Modals/AssignedMember";
import TaskDetailFunctions from "./functions";


const MyTaskDetails = () => {
    const {
        getTaskDetail,
        taskData,
        loader,
        loaction,
        navigate,
        values,
        setValues,
        isError,
        handleSubmitComment,
        handleChange,
        defaultValues,
        handleTaskCompleted,
        showAssignedModal,
        setShowAssignedModal
    } = TaskDetailFunctions();


    useEffect(() => {
        if (loaction && loaction.state && loaction.state.id) {
            getTaskDetail(loaction.state.id);
            setValues(defaultValues);
        }
        else {
            navigate(-1);
        }
    }, []);


    return (
        <div className="task_detail_section">
            <WithoutImageHeader
                header={Constants.MY_TASKS_DETAIL}
            />
            <Container>
                <Row>
                    {
                        taskData ?
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <div className="task_detail_area">
                                    <div className="date_num_area">
                                        <div className="left_date_area">
                                            {/* <p><FontAwesomeIcon icon={faCalendarMinus} className="date_icon" />13 Aug 2023</p> */}
                                            <div className="date_img">
                                                <Image
                                                    src={CalendarBlack}
                                                    alt="..."
                                                />
                                            </div>
                                            <p>{taskData.created ? dateFormat(taskData.created) : ''}</p>
                                        </div>
                                        <div className="right_num_area">
                                            {
                                                taskData.case_id ?
                                                    <p>MR : #{taskData.case_id}</p>
                                                    :
                                                    null
                                            }
                                        </div>
                                    </div>
                                    <div className="inner_profile_area">
                                        <div className="left_profile_area">
                                            <div className="img_area">
                                                <Image
                                                    variant="left"
                                                    src={Card1}
                                                    alt="..."
                                                />
                                            </div>
                                        </div>
                                        {
                                            taskData ?
                                                <div className="right_profile_area">
                                                    <div className="info_main">
                                                        <div className="left_area">
                                                            <h3>{taskData.patient_name ? taskData.patient_name : ''}</h3>
                                                            <div className="gender_area">
                                                                <p><FontAwesomeIcon icon={faVenus} className="gen_icon" />{taskData.gender ? taskData.gender : ""}</p>
                                                                {taskData.cases && taskData.cases.length > 0 ?
                                                                    <span>
                                                                        {taskData.cases[0].ward_title ? taskData.cases[0].ward_title : ''}
                                                                    </span>
                                                                    :
                                                                    null
                                                                }
                                                            </div>
                                                            <div className="icons_area">
                                                                <p><Image src={Calendar} alt="..." className="icon_calender" />{taskData.dob ? dateFormat(taskData.dob) : ''}</p>
                                                                {
                                                                    taskData.cases && taskData.cases.length > 0 ?
                                                                        <>
                                                                            <p><FontAwesomeIcon icon={faBed} className="icon_one" />{taskData.cases[0].bed_number ? `Bed #${taskData.cases[0].bed_number}` : ''}</p>
                                                                            <p><FontAwesomeIcon icon={faHouse} className="icon_one" />{taskData.cases[0].room_title ? taskData.cases[0].room_title : ''}</p>
                                                                        </>
                                                                        :
                                                                        null
                                                                }

                                                            </div>
                                                        </div>
                                                        <div className="right_area">
                                                            <div className="text">
                                                                {
                                                                    taskData.uh_id ?
                                                                        <p>UHID : {taskData.uh_id}</p> : null
                                                                }
                                                                <span>{taskData.task_status && parseInt(taskData.task_status) === 1 ? "Completed" : 'Pending'}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                    <div className="patient_information">
                                        <Card>
                                            <Card.Body>
                                                <div className="left_area">
                                                    <div className="inner_left_area">
                                                        <ul>
                                                            {
                                                                taskData.cases && taskData.cases.length > 0 ?
                                                                    <li>
                                                                        <div className="details">
                                                                            <h5>Ward</h5>
                                                                            <h5>:</h5>
                                                                        </div>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                taskData.assign_by ?
                                                                    <li>
                                                                        <div className="details">
                                                                            <h5>Assigned by</h5>
                                                                            <h5>:</h5>
                                                                        </div>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                taskData.assigned_members && taskData.assigned_members.length > 0 ?
                                                                    <li>
                                                                        <div className="details">
                                                                            <h5>Assigned To</h5>
                                                                            <h5>:</h5>
                                                                        </div>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                taskData.priority ?
                                                                    <li>
                                                                        <div className="details">
                                                                            <h5>Priority</h5>
                                                                            <h5>:</h5>
                                                                        </div>
                                                                    </li>
                                                                    :
                                                                    null

                                                            }
                                                            {
                                                                taskData.start_date ?
                                                                    <li>
                                                                        <div className="details">
                                                                            <h5>Task Date</h5>
                                                                            <h5>:</h5>
                                                                        </div>
                                                                    </li>
                                                                    :
                                                                    null

                                                            }
                                                            {
                                                                taskData.start_time && taskData.end_time ?
                                                                    <li>
                                                                        <div className="details">
                                                                            <h5>Time allotted</h5>
                                                                            <h5>:</h5>
                                                                        </div>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                parseInt(taskData.task_status) === 1 ?
                                                                    <li>
                                                                        <div className="details">
                                                                            <h5>Completed on</h5>
                                                                            <h5>:</h5>
                                                                        </div>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                        </ul>

                                                    </div>
                                                    <div className="inner_right_area">
                                                        <ul>
                                                            {
                                                                taskData.cases && taskData.cases.length > 0 ?
                                                                    <li>
                                                                        <span>{taskData.cases[0].ward_title}</span>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                taskData.assign_by ?
                                                                    <li>
                                                                        <h5 className="space_txt">{taskData.assign_by}</h5>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                taskData.assigned_members && taskData.assigned_members.length > 0 ?
                                                                    <li>
                                                                        <h5 className="space_txt">{taskData.assigned_members[0].name}</h5>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                taskData.priority && parseInt(taskData.priority) === 1 ?
                                                                    <li>
                                                                        <a className="low" type="button">Low</a>
                                                                    </li>
                                                                    :
                                                                    taskData.priority && parseInt(taskData.priority) === 2 ?
                                                                        <li>
                                                                            <a className="medium" type="button">Medium</a>
                                                                        </li>
                                                                        :
                                                                        taskData.priority && parseInt(taskData.priority) === 3 ?
                                                                            <li>
                                                                                <a className="high" type="button">High</a>
                                                                            </li>
                                                                            :
                                                                            null
                                                            }
                                                            {
                                                                taskData.start_date ?
                                                                    <li>
                                                                        <h5 className="date_space">{dateFormat(taskData.start_date)}</h5>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                taskData.start_time && taskData.end_time ?
                                                                    <li>
                                                                        <h5 className="date_space">{timeFormat(taskData.start_time)} to {timeFormat(taskData.end_time)}</h5>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                            {
                                                                parseInt(taskData.task_status) === 1 ?
                                                                    <li>
                                                                        <h5 className="date_space">{dateFormat(taskData.completed_on)}{" "}{timeFormat(taskData.completed_on)}</h5>
                                                                    </li>
                                                                    :
                                                                    null
                                                            }
                                                        </ul>
                                                    </div>
                                                    {/* <div className="text_line">
                                                <p>Robert William</p>
                                            </div>
                                            <div className="low_text">
                                                <p>Low</p>
                                            </div>
                                            <div className="txt">
                                                <p>5 June, 2023</p>
                                            </div>
                                            <div className="txt space">
                                                <p>11:00AM to 12:00PM</p>
                                            </div>
                                            <div className="txt">
                                                <p>12 june, 2023 11:00AM</p>
                                            </div> */}
                                                </div>
                                                {/* <div className="right_area">
                                            <div className="images_section">
                                                <div className="img_one">
                                                    <Image src={img_1} alt="..." />
                                                </div>
                                                <div className="img_one">
                                                    <Image src={img_1} alt="..." />
                                                </div>
                                                <div className="img_two">
                                                    <p>3+</p>
                                                </div>
                                            </div>
                                        </div> */}
                                                {
                                                    taskData && taskData.assigned_members && taskData.assigned_members.length > 0 ?
                                                        <div className="right_area">
                                                            <div className="inner_details" onClick={() => setShowAssignedModal(true)}>
                                                                <div className="img_one">
                                                                    <Image src={User1} alt="..." />
                                                                </div>
                                                                {
                                                                    taskData.assigned_members.length > 1 ?
                                                                        <div className="img_two">
                                                                            <Image src={User2} alt="..." />
                                                                        </div>
                                                                        :
                                                                        null

                                                                }
                                                                {
                                                                    taskData.assigned_members.length === 3 ?
                                                                        <div className="img_one">
                                                                            <Image src={User1} alt="..." />
                                                                        </div>
                                                                        :
                                                                        taskData.assigned_members.length > 3 ?
                                                                            <div className="img_three_area">
                                                                                <div className="details" >
                                                                                    <h6>{taskData.assigned_members.length > 3 ? `3 +` : ""}</h6>
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            null
                                                                }
                                                            </div>
                                                            <div className="edit_area">
                                                                <a type="button">Edit Details</a>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                }
                                            </Card.Body>
                                        </Card>
                                        {
                                            taskData.description ?
                                                <Card className="description_card">
                                                    <Card.Body>
                                                        <div className="description_area">
                                                            <h5>Description</h5>
                                                            <p>{taskData.description}</p>
                                                        </div>
                                                        <div className="description_edit">
                                                            <a type="button">Edit Details</a>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                                :
                                                null
                                        }
                                    </div>

                                    <div className="bottom_area">
                                        {
                                            parseInt(taskData.task_status) === 0 ?
                                                <a type="button" onClick={() => handleTaskCompleted()}>Task Complete</a>
                                                :
                                                null
                                        }
                                        <Card>
                                            <Card.Body>
                                                <Form>
                                                    <div className="comment_area">
                                                        <h6>Comment</h6>
                                                        <div className="count">
                                                            <span>{taskData && taskData.comments ? taskData.comments.length : ''}</span>
                                                        </div>
                                                    </div>
                                                    <div className="send_comment">
                                                        <Form.Group className="form-group">
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Type your comment here"
                                                                value={values.comment}
                                                                className={isError.comment.message
                                                                    ? "error_border"
                                                                    : ""}
                                                                onChange={(e) => handleChange("comment", e.target.value)}
                                                            />
                                                            {isError.comment.message ? (
                                                                <p className="text-danger mt-2">
                                                                    {isError.comment.message}
                                                                </p>
                                                            ) : null}
                                                            <FontAwesomeIcon icon={faFaceSmile} className="emoji_icon" />
                                                        </Form.Group>
                                                        <a
                                                            type="button"
                                                            onClick={() => handleSubmitComment()}
                                                        >
                                                            Send</a>
                                                    </div>
                                                </Form>
                                                {
                                                    taskData && taskData.comments ?
                                                        taskData.comments.map((item, i) => (
                                                            <div className="comments" key={i}>
                                                                <div className="comment_details">
                                                                    <div className="image_one">
                                                                        <Image
                                                                            src={Task1}
                                                                            alt="..."
                                                                        />
                                                                    </div>
                                                                    <h6>{item.from_name ? item.from_name : ''}</h6>
                                                                    <p>{item.created ? timeInAgoFormat(item.created) : ''}</p>
                                                                </div>
                                                                <p>{item.comment ? item.comment : ''}</p>
                                                                {/* <div className="like">
                                                                    <span>2 Likes</span>
                                                                </div> */}
                                                            </div>
                                                        ))
                                                        :
                                                        null
                                                }
                                                {/* // <div className="comments">
                                                //     <div className="comment_details">
                                                //         <div className="image_one">
                                                //             <Image src={Task2} alt="..." />
                                                //         </div>
                                                //         <h6>Dianne Russell</h6>
                                                //         <p>24 min</p>
                                                //     </div>
                                                //     <p>
                                                //         Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br />Etiam sem orci, viverra sit amet consectetur ut, iaculis <br />at turpis
                                                //     </p>
                                                //     <div className="like">
                                                //         <span>1 Like</span>
                                                //     </div>
                                                // </div>
                                                // <div className="comments">
                                                //     <div className="comment_details">
                                                //         <div className="image_one">
                                                //             <Image src={Task3} alt="..." />
                                                //         </div>
                                                //         <h6>Esther Howard</h6>
                                                //         <p>26 min</p>
                                                //     </div>
                                                //     <p>
                                                //         Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam sem orci
                                                //     </p>
                                                //     <div className="like">
                                                //         <span>12 Likes</span>
                                                //     </div>
                                                // </div> */}
                                            </Card.Body>
                                        </Card>
                                    </div>
                                </div>
                            </Col>
                            :
                            null
                    }
                </Row>
            </Container>
            {
                showAssignedModal && taskData && taskData.assigned_members && taskData.assigned_members.length > 0 ? (
                    <AssignedMemberModal
                        show={showAssignedModal}
                        assignedMembers={taskData && taskData.assigned_members}
                        close={() => setShowAssignedModal(false)}
                    />
                ) : null
            }
        </div >
    );
};

export default MyTaskDetails;
